/**
 * Rebuy Widget Customizations
 * 
 * - Disables SmartCart (using theme's cart drawer instead)
 * - Refreshes cart drawer when products are added via Rebuy
 * - Re-initializes Rebuy widgets on cart changes (for empty cart state)
 * - Removes Rebuy's default CSS (custom styles in base.css)
 */

(function() {
  if (window.RebuyCustomizerLoaded) return;
  window.RebuyCustomizerLoaded = true;

  // Disable Rebuy SmartCart - we use the theme's cart drawer
  document.addEventListener('rebuy:smartcart.ready', () => {
    if (typeof Rebuy !== 'undefined' && Rebuy.SmartCart) {
      Rebuy.SmartCart.destroy();
    }
  });

  // Re-init Rebuy on cart changes (handles empty cart state)
  document.addEventListener('rebuy:cart.change', () => {
    setTimeout(() => {
      if (typeof Rebuy !== 'undefined') Rebuy.init();
    }, 100);
  });

  // Re-init Rebuy on theme cart updates (catches section re-renders)
  document.addEventListener('cart:update', () => {
    setTimeout(() => {
      if (typeof Rebuy !== 'undefined') Rebuy.init();
    }, 200);
  });

  // Watch for Rebuy widget containers added to DOM (for empty cart state)
  const widgetObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.nodeType === 1 && (node.matches?.('[data-rebuy-id]') || node.querySelector?.('[data-rebuy-id]'))) {
          setTimeout(() => {
            if (typeof Rebuy !== 'undefined') Rebuy.init();
          }, 50);
          return;
        }
      }
    }
  });
  widgetObserver.observe(document.body, { childList: true, subtree: true });

  // Intercept fetch to refresh cart drawer on add
  const originalFetch = window.fetch;
  window.fetch = function(url, options) {
    const urlString = typeof url === 'string' ? url : url.toString();
    const isCartAdd = urlString.includes('/cart/add');

    return originalFetch.apply(this, arguments).then(response => {
      if (isCartAdd && response.ok) {
        response.clone().json().then(() => {
          setTimeout(() => {
            const sectionId = document.querySelector('cart-items-component')?.dataset?.sectionId;
            const sectionsParam = sectionId ? `?sections=${sectionId}` : '';

            originalFetch('/cart.js' + sectionsParam)
              .then(r => r.json())
              .then(cart => {
                document.dispatchEvent(new CustomEvent('cart:update', {
                  bubbles: true,
                  detail: {
                    resource: cart,
                    data: {
                      sections: cart.sections,
                      itemCount: cart.item_count
                    }
                  }
                }));

                // Scroll cart drawer to top after adding product
                setTimeout(() => {
                  const cartItems = document.querySelector('.cart-drawer__items');
                  if (cartItems) {
                    cartItems.scrollTo({ top: 0, behavior: 'smooth' });
                  }
                }, 150);
              });
          }, 100);
        });
      }
      return response;
    });
  };

  // Remove Rebuy's default CSS to use our custom styles
  function removeRebuyCss() {
    document.querySelectorAll('link[href*="rebuyengine.com"]').forEach(el => el.remove());
    document.querySelectorAll('style[id*="rebuy"], style[id="smart-cart-style"]').forEach(el => el.remove());
  }
  
  removeRebuyCss();
  
  // Observe for dynamically added Rebuy stylesheets
  const cssObserver = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      for (const node of mutation.addedNodes) {
        if (node.tagName === 'LINK' && node.href?.includes('rebuyengine.com')) {
          node.remove();
        }
        if (node.tagName === 'STYLE' && node.id && (node.id.includes('rebuy') || node.id === 'smart-cart-style')) {
          node.remove();
        }
      }
    }
  });
  cssObserver.observe(document.head, { childList: true });
})();
